import React from 'react';
import styles from 'routes/vendorRe/pages/VendorCctv.module.css';
import VerticalFlex from 'routes/vendorRe/containers/commons/VerticalFlex';
import FlexChild from 'routes/vendorRe/containers/commons/FlexChild';
import HorizontalFlex from 'routes/vendorRe/containers/commons/HorizontalFlex';
import P from 'routes/vendorRe/containers/commons/P';
import { 
    contentStart,
    saleFontSize1,
    
} from 'routes/vendorRe/constraint/constraints';
import cctvTestImg from 'routes/vendorRe/images/cctv_test_img.png';

const VendorCctvList = () => {
    return (
        <FlexChild>
            <div className={styles.borderTop}>
                <HorizontalFlex gap="2em">
                    <FlexChild flex="1">
                        <img className={styles.cctvImg} src={cctvTestImg} alt='cctv 이미지' />
                    </FlexChild>
                    <FlexChild flex="11">
                        <VerticalFlex gap="1.5em">
                            <FlexChild alignItems={contentStart}>
                                <P size={saleFontSize1}>2021-03-01 / 09:00:00</P>
                            </FlexChild>
                            <FlexChild>
                                <HorizontalFlex gap="2em">
                                    <FlexChild>
                                        <div className={styles.button}>다시보기</div>
                                        <div className={styles.button}>다운로드</div>
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                        </VerticalFlex>
                    </FlexChild>
                </HorizontalFlex>
            </div>
        </FlexChild>
    );
};

export default VendorCctvList;